import service from "@/utils/request";
import * as apiRequest from "@/api/Type";
const url = require("@/utils/data").url;

/**
 * 项目菜单查询
 * @param data {apiRequest.GetMenuListForProjectIdRequest}
 */
export const getMenuListForProjectId = (data: apiRequest.GetMenuListForProjectIdRequest) => {
    return service({
        url: url + "/menu/project/query",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 系统菜单查询
 * @param data {apiRequest.GetMenuListForProjectIdRequest}
 */
export const getSysMenuListForProjectId = (data: apiRequest.GetMenuListForProjectIdRequest) => {
    return service({
        url: url + "/menu/sys/query",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 添加菜单
 * @param data {apiRequest.AddMenu}
 */
export const addProjectMenu = (data: apiRequest.AddMenu) => {
    return service({
        url: url + "/menu/add",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 修改项目菜单
 * @param data {apiRequest.ModifyMenu}
 */
export const modifyMenu = (data: apiRequest.ModifyMenu) => {
    return service({
        url: url + "/menu/modify",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 删除项目菜单
 * @param data {apiRequest.DelMenu}
 */
export const delMenu = (data: apiRequest.DelMenu) => {
    return service({
        url: url + "/menu/del",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 添加文章
 * @param data {apiRequest.AddArticleToMenu}
 */
export const addArticleToMenu = (data: apiRequest.AddArticleToMenu) => {
    return service({
        url: url + "/menu/add/article",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}
